import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireErrorDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "flex-start",
        flexDirection: "row",
        minWidth: 0
    },
    text: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: QuestionnaireErrorDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
